import { interceptor } from '@/common/utils/interceptor';
import * as Constants from '@/common/utils/constants';

export default [
  {
    path: '/other/multi-patient/:mode',
    component: () => import('@/pages/other/multi-patient'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
    }
  },
  {
    path: '/other/instructions',
    component: () => import('@/pages/other/instructions'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
    }
  },
  {
    path: '/other/medical-guide',
    component: () => import('@/pages/other/medical-guide'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_NO);
    }
  }
];
